<template>    
    <BaseModal
        :id="'static'"
        :title="title"
        message="Select a Cost Center, enter a Department name, click save."
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "content_header",
        "rest_api",
        "notifications",
        "notyf",
        "axios",
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            levels:         [],
            areas:          [],
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
        }
    },

    methods:{

    },

    mounted(){

    }
    
}
</script>